// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"p8-z","refreshPageWarning":"q8-z","redirectMessageText":"r8-z"};